export default __webpack_public_path__ + "static/media/arbitrum.abae01ba.svg";